<script setup lang="ts">
import AppHeader from '@/components/layout/AppHeader.vue';
import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group';
import { useTheme } from '@/composables/useTheme';
import { Sun, Moon, Monitor } from 'lucide-vue-next';

const { theme, setTheme } = useTheme();
</script>

<template>
  <div class="min-h-screen bg-background">
    <AppHeader />

    <main class="max-w-4xl mx-auto px-4 py-8">
      <div class="space-y-6">
        <div>
          <h2 class="text-2xl font-semibold">
            Settings
          </h2>
          <p class="text-muted-foreground mt-1">
            Customize your LLM-SR experience
          </p>
        </div>

        <div class="bg-card rounded-lg p-6 border border-border">
          <h3 class="font-semibold text-lg mb-2">
            Appearance
          </h3>
          <p class="text-sm text-muted-foreground mb-4">
            Choose how LLM-SR looks to you.
          </p>
          <ToggleGroup
            type="single"
            :model-value="theme"
            variant="outline"
            @update:model-value="(val) => val && setTheme(val as 'light' | 'dark' | 'system')"
          >
            <ToggleGroupItem value="light" class="gap-2 px-3">
              <Sun class="size-4" />
              Light
            </ToggleGroupItem>
            <ToggleGroupItem value="dark" class="gap-2 px-3">
              <Moon class="size-4" />
              Dark
            </ToggleGroupItem>
            <ToggleGroupItem value="system" class="gap-2 px-3">
              <Monitor class="size-4" />
              System
            </ToggleGroupItem>
          </ToggleGroup>
        </div>
      </div>
    </main>
  </div>
</template>
